import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  HStack,
  Icon,
  Text
} from "@chakra-ui/react";
import { FaComments } from "react-icons/fa";
import Notes from "../../../../../components/notes/Notes";

const NotesModal = ({
  ticket,
  ticketID,
  state,
  revalidator,
}) => {
  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={3}>
            <Icon as={FaComments} color="blue.500" />
            <Text>Notlar</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Notes
            object_model="ticket.ticket"
            object_id={ticketID}
            revalidator={revalidator}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={state.onClose}>
            Kapat
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NotesModal;